import { withInstall } from '../../utils/install';
import CheckboxGroup from './index.vue';

export const IvueCheckboxGroup = withInstall(CheckboxGroup);
export default IvueCheckboxGroup;

export * from './index.vue';
